import {Font} from '../../classes/font';
import {uniq} from 'lodash';
import WebFont from 'webfontloader';
import {inject} from 'vue';
import {fonts as defaultFonts} from './fonts';
import {captureException} from '@sentry/vue';

/**
 * @name fontLoader
 */
const loadedFonts = new Set();

export const fontLoader = (inputs = []) => {
  const injectedFonts = inject('integrationFonts');
  const integrationFonts = injectedFonts?.value ?? [];
  const fonts = [...defaultFonts, ...integrationFonts].sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  );

  const webLoadInput = {
    fontactive: familyName => {
      $eventBus.emit('webfonts-loaded', familyName);
    },

    fontinactive: () => {
      $eventBus.emit('webfonts-failed-to-load');
    },
  };

  if (!fonts?.length) {
    return;
  }

  // Get the unique fonts which need to be loaded
  const unloadedFonts = uniq(inputs).filter(
    fontName => !loadedFonts.has(fontName)
  );

  unloadedFonts.forEach(fontName => {
    loadedFonts.add(fontName);

    let font;

    if (typeof fontName === 'string') {
      font = fonts.find(f => f.name === fontName);
    }

    if (font === undefined) {
      font = new Font(fontName);
    }

    /**
     * Adds ?display=swap to the last font in the array so that it is at the end of the request url:
     * https://fonts.googleapis.com/css?family=Lato:400,700|Poppins:400,700&display=swap
     */
    if (fontName === unloadedFonts[unloadedFonts.length - 1]) {
      font.display = 'swap';
    }

    if (font.source === 'typekit') {
      if (!webLoadInput.typekit) {
        webLoadInput.typekit = {id: font.kitId};
      }
    } else if (font.source === 'drive') {
      const face = new FontFace(font.displayCssName, `url("${font.url}")`);
      face
        .load()
        .then(loadedFace => {
          document.fonts.add(loadedFace);
        })
        .catch(error => {
          captureException(error);
        });
    } else {
      if (!webLoadInput[font.source]) {
        webLoadInput[font.source] = {
          families: [],
          urls: [],
        };
      }
      webLoadInput[font.source].families?.push(font.asString);
    }

    if (font.url && !(font.source === 'drive')) {
      webLoadInput[font.source].urls.push(font.url);
    }
  });

  WebFont.load(webLoadInput);
};
